export default {
	StockPlanOrder: {
		id: 'stockPlanOrder',
		label: '采购计划单',
		selectedList: [],
		mistakeCheckList: [
			{
				id: 'Must',
				title: '本品必订',
				mistakeType: 'error'
			}, {
				id: 'Repeat',
				title: '重复品项',
				mistakeType: 'error'
			}, {
				id: 'ZeroAmount',
				title: '申请数量为0',
				mistakeType: 'error'
			}, {
				id: 'MustOrder',
				title: '关联必订品项',
				mistakeType: 'error'
			}, {
				id: 'ItemHouseRelation',
				title: '仓库与品项关联关系',
				mistakeType: 'error'
			}, {
				id: 'InsufficientInventory',
				title: '卖方库存不足',
				mistakeType: 'error'
			}
		]
	}
}
